export default "__VITE_ASSET__BJ7$3O71__"